import { call, put, takeLatest } from "redux-saga/effects";
import { UserEnrollmentFailedDevicesServiceFailure, UserEnrollmentFailedDevicesServiceInit, UserEnrollmentFailedDevicesServiceSuccess } from "./UserEnrollmentFailedDevicesSlice";
import { _API_ENDPOINT, LOCALSESSIONDATAKEYS } from "../../constants/AppConstants";
import { _CALLGETAPI } from "../../api/apiHandler";
import { getLocalSessionData } from "../../utils/Authentication/handleUserSession";

function _GetUserEnrollmentFailedDevices(userId) {
    const endpoint = _API_ENDPOINT.GET_USER_ENROLLMENT_FAILED_DEVICES;

    const payload = {
        params: {
            "userId": userId
        }
    }

    return _CALLGETAPI(endpoint, payload)
        .then(response => {
            return response
        })
        .catch((error) => {
            throw error;
        });
}

function* handleEnrollmentFailedDevices(action) {
    try {
        const userId = getLocalSessionData(LOCALSESSIONDATAKEYS.UID);
        const apiResppnse = yield call(_GetUserEnrollmentFailedDevices, userId);

        /** 
         * Right now, this API is used only to display enrollment failed devices in MyDevices pages. 
         * Do not throw any error if API returns Failure as action status, 
         * because rest of the MyDevicePage should load as it is with out any errors
         */
        yield put(UserEnrollmentFailedDevicesServiceSuccess(apiResppnse));
    } catch (error) {
        yield put(UserEnrollmentFailedDevicesServiceFailure(error.message));
    }
}

export default function* watchUserEnrollmentFailedDevicesService() {
    yield takeLatest(UserEnrollmentFailedDevicesServiceInit.type, handleEnrollmentFailedDevices);
}